import useOpen from '@/hooks/useOpen';
import AppContent from '@/components/AppContent';
import prefetchPresetFeedData from '@/utils/query/prefetchPresetFeedData';

import '@/utils/dev/logger';

export const App = () => {
  const isOpen = useOpen(() => {
    prefetchPresetFeedData();
  });

  if (!isOpen) {
    return null;
  }

  return <AppContent />;
};

export default App;
